import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCaseList } from "dot/Components/Content/CaseDetailsPage/FindCase/services/CaseDetailsThunk";
import {
  extensionOfferTools,
  STATUS
} from "dot/Components/Misc/CaseDetails_System";
import { setProp } from "Store/Actions";
import { setProPayloadT } from "Store/Actions/ts/index";
const initialData = {
  caseType: "",
  sCRMID: "",
  extOffer: extensionOfferTools.MPW_GSM,
  subType: "",
  isServiceOnlySubType: false,
};
const findCaseSlice = createSlice({
  name: "findCase",
  initialState: {
    data: initialData,
    status: STATUS.IDLE,
    caseList: {
      isLoading: false,
      data: [] as any[],      
    },
    // Redirect info
    redirectModal: {
      isOpen: false,
      message: "",
    },
    // Track if form has been loaded after CRM data fetch
    isFormLoaded: false,
  },
  reducers: {
    setDataFC(state, action) {
      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.value,
      };
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    resetFC(state,) {
      state.data = initialData;
      state.status = STATUS.IDLE;
    },
    // setTheme(state, action) {
    //   state.theme = { ...state.theme, [action.payload.key]: action.payload };
    // },
    setRedirectModal(state, action) {
      state.redirectModal = {
        ...state.redirectModal,
        ...action.payload,
      };
    },
    setCaseList(state, action) {
      const { isLoading, data } = action.payload;
      state.caseList = {
        isLoading: isLoading,
        data: data
      };
    },
    setFormLoaded(state, action) {
      state.isFormLoaded = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(setProp, (state, action: PayloadAction<setProPayloadT>) => {
      if (action.payload.slice === findCaseSlice.name) {
        state.data = {
          ...state.data,
          [action.payload.key]: action.payload.value,
        };
      }
    })
    // Handle fetchCaseList actions
    .addCase(fetchCaseList.pending, (state) => {
      state.caseList.isLoading = true;
    })
    .addCase(fetchCaseList.fulfilled, (state, action) => {
      state.caseList.isLoading = false;
      state.caseList.data = action.payload?.data || [];
    })
    .addCase(fetchCaseList.rejected, (state, action) => {
      state.caseList.isLoading = false;
      state.caseList.data = [];
    });
  }
});

export default findCaseSlice.reducer;
export const { setDataFC, setStatus, resetFC, setRedirectModal, setCaseList, setFormLoaded } = findCaseSlice.actions;
